import { render, staticRenderFns } from "./sos_register.vue?vue&type=template&id=5910025f&scoped=true&"
import script from "./sos_register.vue?vue&type=script&lang=js&"
export * from "./sos_register.vue?vue&type=script&lang=js&"
import style0 from "./sos_register.vue?vue&type=style&index=0&id=5910025f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5910025f",
  null
  
)

export default component.exports